import React from 'react'
import '../../css/table.css'
import { orderBy } from 'lodash'
import ReactTable from 'react-table'
import Card from 'components/Card/Card.jsx'
import { db } from '../../services/firebase'
import Modal from 'components/Modal/Modal.jsx'
import SweetAlert from 'react-bootstrap-sweetalert'
import FabricLineForm from '../../forms/FabricLineForm.jsx'
import Button from 'elements/CustomButton/CustomButton.jsx'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import { Grid, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'

export default class FabricLines extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            fabricLines: [],
            loading: false,
            fabricLineModal: false,
            alert: null,
            targetFabricLine: null
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    componentDidMount() {
        this._fetchFabricLines()
    }

    render() {
        const { fabricLines, loading, alert } = this.state
        return (
            <div className='main-content'>
                {alert}
                {this.fabricLineModal()}
                <Card content={
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Button
                                    bsStyle='default'
                                    wd
                                    className='pull-right'
                                    style={{ marginBottom: 10 }}
                                    onClick={() => {
                                        this.props.resetForm('FabricLineForm')
                                        this.setState({ fabricLineModal: true, targetFabricLine: null })
                                    }}
                                >
                                    Adicionar Faixa
                            </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <ReactTable
                                    columns={[
                                        { Header: 'Nome', accessor: 'name' },
                                        {
                                            Header: 'Ações', accessor: '',
                                            Cell: ({ value }) => (this._renderTableActions(value))
                                        }
                                    ]}
                                    data={orderBy(fabricLines, ['name', 'asc'])}
                                    onFetchData={this._fetchFabricLines}
                                    loading={loading}
                                    defaultPageSize={10}
                                    className='-striped -highlight'
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando'
                                    noDataText='Nenhuma faixa encontrada'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='Registros'
                                />
                            </Col>
                        </Row>
                    </Grid>
                } />
            </div>
        )
    }

    fabricLineModal = () => {
        const { fabricLineModal, targetFabricLine } = this.state
        return (
            <Modal
                className='modal__big'
                title={targetFabricLine ? 'Atualizar faixa' : 'Adicionar faixa'}
                isOpen={fabricLineModal}
                content={
                    <FabricLineForm
                        initialValues={targetFabricLine}
                        onSubmit={values => targetFabricLine ? this._updateFabricLine(values) : this._addFabricLine(values)}
                        handleCancel={() => this.setState({ fabricLineModal: false })}
                    />
                }
            />
        )
    }

    _renderTableActions = value => (
        <div style={{ textAlign: 'center' }}>
            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.setState({ targetFabricLine: value, fabricLineModal: true })}
                >
                    <FontAwesomeIcon className='text-dark' icon='edit' />
                </a>
            </OverlayTrigger>

            {/* <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                >
                    <FontAwesomeIcon className='text-dark' icon='trash' />
                </a>
            </OverlayTrigger> */}
        </div>
    )

    /**************** 
      Fetch data from Firestore
  *****************/

    _fetchFabricLines = () => {
        this.setState({ loading: true })
        db.collection('fabric_lines').onSnapshot(snapshot =>
            !snapshot.empty
                ? this._passFabricLinesToState(snapshot)
                : this.setState({ loading: false })
        )
    }

    _passFabricLinesToState = snapshot => {
        const fabricLines = []
        snapshot.forEach(fabricLine => fabricLines.push({ ...fabricLine.data(), id: fabricLine.id }))
        return this.setState({ loading: false, fabricLines })
    }

    /**************** 
      Add data to Firestore
  *****************/

    _addFabricLine = data => {
        this.setState({ fabricLineModal: false })
        this.waitAlert('Adicionando faixa', true)

        db.collection('fabric_lines').add(data)
            .then(() => {
                this.hideAlert()
                this.props.notify('Faixa de tecido adicionada.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Erro ao adicionar faixa de tecido.', 'error')
            })
    }

    /**************** 
      Update Firestore data
  *****************/

    _updateFabricLine = data => {
        this.setState({ fabricLineModal: false })
        this.waitAlert('Atualizando faixa', true)

        const { targetFabricLine } = this.state

        //this way to strip ID property that returns from redux-form
        db.collection('fabric_lines').doc(targetFabricLine.id).update({ name: data.name })
            .then(() => {
                this.hideAlert()
                this.setState({ targetFabricLine: null })
                this.props.notify('Faixa de tecido atualizada.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.setState({ targetFabricLine: null })
                this.props.notify('Erro ao atualizar faixa de tecido.', 'error')
            })
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

}



// WEBPACK FOOTER //
// ./src/views/FabricLines/FabricLines.jsx